import styled from 'styled-components'

import AlertSvg from '@/assets/svgs/alert-fill.svg?react'
import { Text } from '@/components/Text'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AlertIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 32px 0;
`

export const AlertIcon = styled(AlertSvg)`
  color: ${({ theme }) => theme.colors.primary.main};
  width: 48px;
  height: 48px;
`

export const TextContent = styled.div`
  width: 100%;
`

export const Paragraph = styled(Text)`
  margin-top: 12px;
  margin-bottom: 24px;
`

export const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 10px;
`

export const BulletItem = styled.li`
  position: relative;
  padding-left: 20px;

  &:before {
    content: '•';
    position: absolute;
    left: 0;
    font-size: 1.2em;
  }
`

export const CheckboxContainer = styled.div``
